<template>
  <div class="customer_feedback">
    <b-container fluid>
      <div class="top-row">
        <span class="top-row-name">Customer Feedbacks</span>
        <b-button class="top-row-button" variant="success" v-b-modal.add-report>Add</b-button>
      </div>

      <div class="mt-2 search-bar">
        <b-input-group>
          <b-form-input
            type="text"
            v-model="filterCriteria"
            class="form-control"
            placeholder="Type to search"
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="cleanFilterInfo">
              <b-icon icon="x-circle" variant="white"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>

      <div class="mt-2">
        <b-pagination
        v-model="currentPage"
        :page="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"></b-pagination>
      </div>

      <b-table
        pointer
        responsive
        striped
        hover
        @row-clicked="tableRowClickHandler"
        :fields="tableFields"
        :filter="filterCriteria"
        :items="displayedReports"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >
      
      </b-table>

      <b-modal size="lg" id="add-report" title="New Report" hide-footer>
        <b-form @submit.prevent="createReport">
          <b-row>
            <b-col v-for="item in formInputs" :key="item.key" :cols="item.cols">
              <label :for="`new-order-input-${item.key}`">{{item.label}}<span style="color: red" v-if="item.mandatory">*</span></label>
              <b-form-input v-if="item.form_type == 'text-input'" :id="`new-order-input-${item.key}`" :type="item.type" v-model="newReport[item.key]" :required="item.mandatory"></b-form-input>
              <b-form-select v-if="item.form_type == 'select'"
                :id="`new-order-input-${item.key}`"
                v-model="newReport[item.key]" 
                :required="item.mandatory"
                :options="selectOptions[item.options]"
              ></b-form-select>
              <b-form-datepicker v-if="item.form_type == 'datepicker'"
                :id="`new-order-input-${item.key}`"
                v-model.trim="newReport[item.key]" 
                :required="item.mandatory"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
              <b-form-textarea
                v-if="item.form_type == 'textarea'"
                :id="`new-order-input-${item.key}`"
                v-model.trim="newReport[item.key]" 
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <b-form-radio-group
                v-if="item.form_type == 'radio'"
                :id="`new-order-input-${item.key}`"
                v-model.trim="newReport[item.key]" 
                :options="radioOptions"
              ></b-form-radio-group>
            </b-col>
          </b-row>
          <div class="mt-4 modal-footer">
            <b-button @click="hideModal('add-report')"> Cancel </b-button>
            <b-button class="ml-1" variant="success" type="submit">
              <span v-if="!isCreating">Create</span>
              <span v-if="isCreating">
                <b-spinner small type="grow"></b-spinner>
                Create...
              </span>
            </b-button>
          </div>
        </b-form>
      </b-modal>

    </b-container>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: 'CustomerFeedback',
  data() {
    return {
      tableFields: [
        { key: "date", label: "Date"},
        { key: "customerName", label: "Name"},
        { key: "salesName", label: "Sales"},
        { key: "cemetery", label: "Cemetery"},
        { key: "location", label: "Location"},
      ],
      filterCriteria: "",
      viewedReport: null,
      currentPage: 1,
      perPage: 20,
      tableIsBusy: true,
      displayedReports: [],
      isCreating: false,
      selectOptions: {
        locationNames: [],
        salesNames: [],
      },
      sales: [],
      salesNames: [],
      radioOptions: ['Excellent', 'Good', 'Fair', 'Poor'],
      newReport: {
        id: "",
        sales: null,
        salesName: "",
        createdDate: "",
        creator: null,
        customerName: "",
        cemetery: "",
        location: "",
        date: "",
        customerProblems: "",
        qualityRate: "",
        staffRate: "",
        recommendRate: "",
        satisficationRate: "",
        improvement: "",
      },
      formInputs: [
        { key: "customerName", label: "Customer", type: "text", form_type: "text-input", mandatory: true, clos: 6},
        { key: "location" ,label: "Location", type: "text", form_type: "select", options: "locationNames", mandatory: true, cols: 6},
        { key: "date", label: "Date", type: "text", form_type: "datepicker", mandatory: true, cols: 6},
        { key: "salesName", label: "Sales", type: "text", form_type: "select", options: "salesNames", mandatory: true, cols: 6},
        { key: "customerProblems", label: "Did you experience any problems accessing our product and services?", type: "text", form_type: "textarea", mandatory: true, cols: 12 },
        { key: "qualityRate", label: "How would you rate the quality of our product?", type: "text", form_type: "radio", mandatory: true, cols: 12 },
        { key: "staffRate", label: "Did you find our staff helpful?", type: "text", form_type: "radio", mandatory: true, cols: 12 },
        { key: "recommendRate", label: "How would you rate the quality of our product", type: "text", form_type: "radio", mandatory: true, cols: 12 },
        { key: "satisficationRate", label: "How would you rate the quality of our product", type: "text", form_type: "radio", mandatory: true, cols: 12 },
        { key: "improvement", label: "How would you rate the quality of our product", type: "text", form_type: "radio", mandatory: true, cols: 12 },
      ],
    }
  },
  props: {
    user: Object,
  },
  computed: {
    rows: function() {
      if (this.displayedReports.length == 0) {
        return 100;
      } else {
        return this.displayedReports.length;
      }
    },
  },
  methods: {
    cleanFilterInfo() {
      this.filterCriteria = "";
    },
    tableRowClickHandler(item) {
      this.viewedReport = Object.assign({}, item);
      //this.$emit("CRMViewOrder", {item: Object.assign({}, item), from: 'CRMOrders'});
      console.log(item);
    },
    createReport() {
      this.isCreating = true;
      const newReportRef = firebase.firestore().collection('customer_feedbacks').doc();

      this.newReport.id = newReportRef.id;

    },
  },
  created() {
    firebase.firestore().collection('store_locations').orderBy('name').onSnapshot((collection) => {
      var locations = collection.docs.map(doc => doc.data());
      for (var i = 0; i < locations.length; i++) {
        this.selectOptions.locations.push(locations[i].name);
      }
    });

    firebase.firestore().collection('cemeteries').orderBy('name').onSnapshot((collection) => {
      const cemeterie_objs = collection.docs.map(doc => doc.data());
      for (var i = 0; i < cemeterie_objs.length; i++) {
        this.cemeteries.push(cemeterie_objs[i].name);
        this.selectOptions.cemeteries.push(cemeterie_objs[i].name);
      }
    });

    firebase
      .firestore()
      .collection("saless")
      .onSnapshot((collection) => {
        this.sales = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.sales.length; i++) {
          this.salesNames.push(this.sales[i].name);
          this.selectOptions.salesNames.push(this.sales[i].name);
        }
      });
  },
}
</script>

<style>

</style>